import { useLocalStorageState } from '@components/component-helpers';

import { InfoBox, InfoBoxProps } from './info-box';

export type DismissibleInfoBoxProps = Omit<InfoBoxProps, 'closable' | 'onClose'> & {
  storageKey: string;
  onClose?: () => void;
};

export const DismissibleInfoBox = ({ storageKey, onClose, ...rest }: DismissibleInfoBoxProps) => {
  const [isDismissed, setIsDismissed] = useLocalStorageState({
    key: storageKey,
    defaultValue: false,
  });

  if (isDismissed) return null;

  return (
    <InfoBox
      {...rest}
      closable
      onClose={() => {
        setIsDismissed(true);
        onClose?.();
      }}
    />
  );
};
